var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Box from "@mui/material/Box/Box";
import Container from "@mui/material/Container/Container";
import FormControl from "@mui/material/FormControl/FormControl";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment/InputAdornment";
import InputLabel from "@mui/material/InputLabel/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import { useEffect, useMemo, useState } from "react";
import { Helmet } from "react-helmet-async";
import SearchTwoToneIcon from '@mui/icons-material/SearchTwoTone';
import HighlightOffTwoToneIcon from '@mui/icons-material/HighlightOffTwoTone';
import ReadMeData from "~/Data/ReadMe.json";
import { PrefixUri } from "~/Utils/Util";
import MiniSearch from 'minisearch';
import Divider from "@mui/material/Divider/Divider";
import { Link } from "react-router-dom";
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import WrapMarkdown from "~/Components/WrapMarkdown";
import useDebounce from "~/Utils/useDebounce";
import LinearProgress from "@mui/material/LinearProgress/LinearProgress";
import Empty from "~/Components/Empty";
// interface SearchResult {
//     Source: Searchable
//     // Matrix: Matrix
// }
var ExtractSearchable = function (_a, prefix) {
    var Title = _a.Title, TitleId = _a.TitleId, Content = _a.Content, SubContents = _a.SubContents;
    var searches = [];
    var thisTitleId = PrefixUri(prefix, TitleId);
    if (!thisTitleId.startsWith("/")) {
        thisTitleId = "/".concat(thisTitleId);
    }
    if (Content !== "") {
        searches.push({
            title: Title,
            content: Content,
            id: thisTitleId,
        });
    }
    for (var index = 0; index < SubContents.length; index++) {
        var eachSubContent = SubContents[index];
        searches.push.apply(searches, ExtractSearchable(eachSubContent, thisTitleId));
    }
    return searches;
};
export default (function () {
    var _a = useDebounce(500), startDebounce = _a.startDebounce, cancelDebounce = _a.cancelDebounce, debouncing = _a.debouncing;
    var _b = useState(""), searchInput = _b[0], setSearchInput = _b[1];
    var readMe = ReadMeData;
    var searchables = useMemo(function () { return __spreadArray([], readMe.map(function (each) { return ExtractSearchable(each, null); }), true).reduce(function (a, v) { return __spreadArray(__spreadArray([], a, true), v, true); }, []); }, []);
    // const idToSearchable: IdToSearchable = useMemo(() => {
    //     const idToSearchable: IdToSearchable = {};
    //     for (let index = 0; index < searchables.length; index++) {
    //         const seachTarget = searchables[index];
    //         idToSearchable[seachTarget.id] = seachTarget;
    //     }
    //     return idToSearchable;
    // }, [searchables]);
    var miniSearch = useMemo(function () {
        var miniSearch = new MiniSearch({
            fields: ['title', 'content'], // fields to index for full-text search
            storeFields: ['title', 'content'] // fields to return with search results
        });
        miniSearch.addAll(searchables);
        return miniSearch;
    }, []);
    // const searchResults: SearchResult[] = useMemo(() => GetSearchResults(searchInput, searchables), [searchInput]);
    // console.log(searchResults.length);
    // const results = miniSearch.search('Rich');
    // console.log(results);
    // const searchResults: SearchResult[] = useMemo(() => miniSearch.search(searchInput), [searchInput]);
    var _c = useState([]), searchResults = _c[0], setSearchResults = _c[1];
    useEffect(function () {
        if (searchInput === "") {
            cancelDebounce();
            setSearchResults([]);
        }
        else {
            startDebounce(function () { return setSearchResults(miniSearch.search(searchInput)); });
        }
    }, [searchInput]);
    // console.log(searchResults);
    return (_jsxs(Container, { maxWidth: "xl", children: [_jsx(Helmet, { children: _jsx("title", { children: "Search | SaintsField" }) }), _jsxs(FormControl, { fullWidth: true, sx: { m: 1 }, variant: "outlined", style: { marginTop: 50 }, children: [_jsx(InputLabel, { htmlFor: "outlined-adornment-search", children: "Search" }), _jsx(OutlinedInput, { id: "outlined-adornment-search", type: 'text', value: searchInput, onChange: function (evt) { return setSearchInput(evt.target.value); }, endAdornment: _jsx(InputAdornment, { position: "end", children: _jsx(IconButton, { onClick: function () { return setSearchInput(""); }, edge: "end", children: searchInput === "" ? _jsx(SearchTwoToneIcon, {}) : _jsx(HighlightOffTwoToneIcon, {}) }) }), label: "Password" })] }), debouncing && _jsx(LinearProgress, {}), searchResults.length === 0 && !debouncing && _jsx(Box, { sx: { minHeight: 200, display: 'flex', justifyContent: 'center', alignItems: 'center' }, children: _jsx(Empty, { children: searchInput === "" ? "Input something to search" : "Nothing found" }) }), searchResults.length > 0 && _jsx(Divider, {}), searchResults.map(function (_a) {
                var id = _a.id, title = _a.title, content = _a.content;
                return _jsxs(Accordion, { slotProps: { transition: { unmountOnExit: true } }, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, {}), children: _jsx(Markdown, { remarkPlugins: [remarkGfm], disallowedElements: ['p'], unwrapDisallowed: true, children: title }) }), _jsxs(AccordionDetails, { children: [_jsx(AccordionActions, { children: _jsx(Button, { component: Link, to: id, children: "Open" }) }), _jsx(WrapMarkdown, { children: content })] })] }, id);
            })] }));
});
